import React from 'react';
import { CalendarIcon, MapPinIcon, ClockIcon, ActivityIcon } from 'lucide-react';
export const UpcomingTrips = () => {
  const trips = [{
    id: 1,
    title: 'Zakynthos Coastal Hike',
    location: 'Greece',
    image: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80',
    date: 'August 15-22, 2023',
    duration: '8 days / 7 nights',
    walkingLevel: 'Level 3'
  }, {
    id: 2,
    title: 'Cyprus Mountain Trail',
    location: 'Cyprus',
    image: 'https://images.unsplash.com/photo-1527824404775-dce343118ebc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    date: 'September 5-12, 2023',
    duration: '8 days / 7 nights',
    walkingLevel: 'Level 4'
  }];
  return <section className="py-16 bg-gray-50 w-full" data-id="element-212">
      <div className="container mx-auto px-4" data-id="element-213">
        <div className="text-center mb-12" data-id="element-214">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-215">
            Upcoming Trips
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-216">
            Join our next adventures and experience the world's most beautiful
            hiking trails
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-217">
          {trips.map(trip => <div key={trip.id} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-218">
              <div className="relative h-64" data-id="element-219">
                <img src={trip.image} alt={trip.title} className="w-full h-full object-cover" data-id="element-220" />
              </div>
              <div className="p-6" data-id="element-221">
                <h3 className="text-xl font-bold text-gray-800 mb-2" data-id="element-222">
                  {trip.title}
                </h3>
                <div className="flex items-center mb-3" data-id="element-223">
                  <MapPinIcon size={18} className="text-teal-600 mr-2" data-id="element-224" />
                  <span className="text-gray-600" data-id="element-225">{trip.location}</span>
                </div>
                <div className="flex items-center mb-3" data-id="element-226">
                  <CalendarIcon size={18} className="text-teal-600 mr-2" data-id="element-227" />
                  <span className="text-gray-600" data-id="element-228">{trip.date}</span>
                </div>
                <div className="flex items-center mb-3" data-id="element-229">
                  <ClockIcon size={18} className="text-teal-600 mr-2" data-id="element-230" />
                  <span className="text-gray-600" data-id="element-231">{trip.duration}</span>
                </div>
                <div className="flex items-center mb-4" data-id="element-232">
                  <ActivityIcon size={18} className="text-teal-600 mr-2" data-id="element-233" />
                  <span className="text-gray-600" data-id="element-234">{trip.walkingLevel}</span>
                </div>
                <a href={`/trips/${trip.id}`} className="block text-center bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-4 rounded-md transition duration-300" data-id="element-235">
                  View Details
                </a>
              </div>
            </div>)}
        </div>
        <div className="text-center mt-10" data-id="element-236">
          <a href="/all-trips" className="inline-block border-2 border-teal-600 text-teal-600 hover:bg-teal-600 hover:text-white font-medium py-2 px-6 rounded-md transition duration-300" data-id="element-237">
            View All Trips
          </a>
        </div>
      </div>
    </section>;
};